import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {Logger} from '@common-lib';
import {ActivatedRoute} from '@angular/router';
import {UsersService} from '../../pages-services/users.service';
import {PermissionsService} from '../../pages-services/permissions.service';
import {ToasterService} from 'angular2-toaster';
import {TranslateService} from '@ngx-translate/core';
import {ConfirmPopupComponent} from '../../components/confirm-popup/confirm-popup.component';

@Component({
    selector: 'app-settings-permissions',
    templateUrl: './settings-permissions.component.html',
    styleUrls: ['./settings-permissions.component.scss']
})

export class SettingsPermissionsComponent implements OnInit {
    editModalRef: BsModalRef;
    selectedRow: {
        id: number,
        role: string,
        resource: string,
        action: string,
        permission: string,
        permissionVal: boolean,
        createdAt?: string,
        new: boolean,
    };
    searchTerm = '';

    @ViewChild('editFormTemplate')
    editFormTemplate: TemplateRef<any>;

    tableConfiguration = {
        searchEnabled: false,
        headerEnabled: true,
        orderEnabled: true,
        globalSearchEnabled: false,
        paginationEnabled: true,
        exportEnabled: false,
        clickEvent: false,
        selectRow: false,
        selectCol: false,
        selectCell: false,
        rows: 50,
        additionalActions: false,
        serverPagination: false,
        isLoading: false,
        detailsTemplate: false,
        groupRows: false,
        paginationRangeEnabled: true,
        collapseAllRows: false,
        checkboxes: false
    };

    columns = [
        {key: 'id', title: 'ID'},
        {key: 'role', title: 'Role'},
        {key: 'resource', title: 'Resource'},
        {key: 'action', title: 'Action'},
        {key: 'permission', title: 'Is Allowed'},
        {key: 'createdAt', title: 'Created At'},
        {key: 'actions', title: ''}
    ];

    data = [];
    rows = [];
    selected = new Set();

    actions = [
        {
            name: 'get',
            title: 'GET'
        }, {
            name: 'post',
            title: 'POST'
        }, {
            name: 'put',
            title: 'PUT'
        }, {
            name: 'delete',
            title: 'DELETE'
        }
    ];

    @ViewChild(ConfirmPopupComponent)
    confirmPopup: ConfirmPopupComponent;

    constructor(
        private route: ActivatedRoute,
        private permissionsService: PermissionsService,
        private modalService: BsModalService,
        private toasterService: ToasterService,
        private translationService: TranslateService,
        private logger: Logger
    ) {
    }

    ngOnInit() {
        this.getList();
    }

    getList() {
        this.permissionsService.getList().subscribe((data) => {
            this.data = data;
            this.search();
        });
    }

    localeChanged() {
        this.getList();
    }

    showEditForm(template: TemplateRef<any>) {
        this.editModalRef = this.modalService.show(template);
    }

    toggleRow({target: {checked}}, row) {
        const index = this.data.indexOf(row);
        if (checked) {
            this.selected.add(index);
        } else {
            this.selected.delete(index);
        }
    }

    isRowSelected(row) {
        return this.selected.has(this.data.indexOf(row));
    }

    eventEmitted($event) {
        switch ($event.event) {
            case 'onSelectAll':
                this.data.forEach((val, key) => {
                    if (this.selected.has(key)) {
                        this.selected.delete(key);
                    } else {
                        this.selected.add(key);
                    }
                });
                break;
            case 'onDoubleClick':
                this.editRow($event.value.row);
                break;
        }
    }

    editRow(row) {
        this.selectedRow = row;
        this.editModalRef = this.modalService.show(this.editFormTemplate);
    }

    saveTranslation() {
        this.editModalRef.hide();
        let data = Object.assign({}, this.selectedRow);
        console.log(data);
        data.permission = data.permissionVal ? 'allow' : 'deny';

        if (data.new) {
            this.permissionsService.add(data).subscribe(async (_data) => {
                this.getList();
                this.search();
                this.toasterService.pop('success', '', await this.translationService.get('webpanel.permissions.permisssion_saved_message').toPromise());
            }, (err) => {
                this.toasterService.pop('error', '', err.message || 'An error occurred');
            });
        } else {

            this.permissionsService.update(data).subscribe(async (_data) => {
                this.getList();
                this.search();
                this.toasterService.pop('success', '', await this.translationService.get('webpanel.permissions.permisssion_saved_message').toPromise());
            }, (err) => {
                this.toasterService.pop('error', '', err.message || 'An error occurred');
            });
        }
    }

    search() {
        if (this.data) {
            this.rows = this.data.filter((r) => this.searchTerm.length === 0 ||
                r.role.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1 ||
                r.resource.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1);

            this.rows = this.rows.map((p) => ({
                ...p,
                permissionVal: p.permission === 'allow'
            }));
        }
    }

    addNew() {
        this.selectedRow = {
            id: null,
            role: null,
            resource: null,
            action: 'get',
            permission: 'Yes',
            permissionVal: true,
            'new': true
        };
        this.editModalRef = this.modalService.show(this.editFormTemplate);
    }

    searchKeyPress(event) {
        if (event.which === 13) {
            this.search();
        }
    }

    async removeItem(item) {
        this.selectedRow = item;

        if (this.selectedRow) {
            this.confirmPopup.show();
        }
    }

    confirm(res) {
        if (res) {
            if (this.selectedRow) {
                this.permissionsService.delete(this.selectedRow).subscribe(async (resp) => {
                    this.selectedRow = null;
                    let successMessage = await this.translationService.get('webpanel.permissions.delete.success_message').toPromise();
                    this.toasterService.pop('success', '', successMessage);
                    this.getList();
                });
            }
        } else {
            this.selectedRow = null;
        }
    }

    decline() {
        this.selectedRow = null;
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/settings-permissions/settings-permissions.component.ts